<template>
    <div id="detail-tab" v-if="!!planningItem">
        <div class="md-body-2">Klant informatie</div>
        <div class="md-caption md-layout">
            <div class="md-layout-item">Klant nummer:</div>
            <div class="md-layout-item">
                {{
                    planningItem.client
                        ? planningItem.client.exact_client_number
                            ? planningItem.client.exact_client_number
                            : '-'
                        : planningItem.client.lead_data.lead_custom_id
                        ? planningItem.client.lead_data.lead_custom_id
                        : '-'
                }}
            </div>
        </div>
        <div class="md-caption md-layout">
            <div class="md-layout-item">Naam:</div>
            <div class="md-layout-item">
                {{
                    planningItem.client
                        ? (planningItem.client.client_data.first_name
                              ? planningItem.client.client_data.first_name
                              : '-') +
                          ' ' +
                          (planningItem.client.client_data.last_name ? planningItem.client.client_data.last_name : '-')
                        : ' '
                }}
            </div>
        </div>
        <div class="md-caption md-layout">
            <div class="md-layout-item">Email:</div>
            <div class="md-layout-item">
                {{
                    planningItem.client
                        ? planningItem.client.client_data.email
                            ? planningItem.client.client_data.email
                            : '-'
                        : ''
                }}
            </div>
        </div>

        <div
            class="md-caption md-layout phone"
            v-if="planningItem.client && planningItem.client.client_data.telephone_number"
        >
            <div class="md-layout-item">Tel.:</div>
            <div class="md-layout-item md-layout">
                <a :href="`tel:${planningItem.client.client_data.telephone_number}`" class="md-layout-item">
                    {{ planningItem.client.client_data.telephone_number }}
                    <md-icon class="md-button md-icon-button md-dense md-layout-item md-raised">call</md-icon>
                </a>
            </div>
        </div>

        <div
            class="md-caption md-layout phone"
            v-if="planningItem.client && planningItem.client.client_data.mobile_phone"
        >
            <div class="md-layout-item">Tel.:</div>
            <div class="md-layout-item">
                <a :href="`tel:${planningItem.client.client_data.mobile_phone}`" class="md-button md-dense">
                    {{ planningItem.client.client_data.mobile_phone }}
                    <md-icon>call</md-icon>
                </a>
            </div>
        </div>

        <div class="md-caption md-layout">
            <div class="md-layout-item">BTW:</div>
            <div class="md-layout-item">
                {{
                    planningItem.client && planningItem.client.client_data.company_data
                        ? planningItem.client.client_data.company_data.vat_number
                            ? planningItem.client.client_data.company_data.vat_number
                            : '-'
                        : ''
                }}
            </div>
        </div>

        <div id="address-block">
            <div>
                <div class="md-body-2">Hoofd adres</div>
                <div class="md-caption">
                    <div class="md-layout-item">
                        {{
                            planningItem.client
                                ? planningItem.client.client_data.main_address.address
                                    ? planningItem.client.client_data.main_address.address
                                    : '-'
                                : ''
                        }}
                    </div>
                    <div class="md-layout-item">
                        {{
                            planningItem.client
                                ? (planningItem.client.client_data.main_address.zip_code
                                      ? planningItem.client.client_data.main_address.zip_code
                                      : '-') +
                                  ' ' +
                                  (planningItem.client.client_data.main_address.city
                                      ? planningItem.client.client_data.main_address.city
                                      : '-')
                                : ''
                        }}
                    </div>
                    <div class="md-layout-item">
                        {{
                            planningItem.client
                                ? (planningItem.client.client_data.main_address.state
                                      ? planningItem.client.client_data.main_address.state
                                      : '-') +
                                  ' ' +
                                  (planningItem.client.client_data.main_address.stateName
                                      ? planningItem.client.client_data.main_address.stateName
                                      : '-')
                                : '-'
                        }}
                    </div>
                    <div class="md-layout-item">
                        {{
                            planningItem.client
                                ? (planningItem.client.client_data.main_address.country
                                      ? planningItem.client.client_data.main_address.country
                                      : '-') +
                                  ' ' +
                                  (planningItem.client.client_data.main_address.countryName
                                      ? planningItem.client.client_data.main_address.countryName
                                      : '-')
                                : ''
                        }}
                    </div>
                </div>
            </div>
            <!-- The visit's own job-site address (was hardcoded to the client's first delivery
                 address, which is the wrong site for multi-address clients). -->
            <div v-if="planningItem.data && planningItem.data.delivery_address">
                <div class="md-body-2">Uitvoerings adres</div>
                <div class="md-caption">
                    <div class="md-layout-item">
                        {{
                            planningItem.data.delivery_address.address
                                ? planningItem.data.delivery_address.address
                                : '-'
                        }}
                    </div>
                    <div class="md-layout-item">
                        {{
                            (planningItem.data.delivery_address.zip_code
                                ? planningItem.data.delivery_address.zip_code
                                : '-') +
                            ' ' +
                            (planningItem.data.delivery_address.city ? planningItem.data.delivery_address.city : '-')
                        }}
                    </div>
                </div>
            </div>
        </div>

        <div id="client-remark-block" v-if="planningItem.client && planningItem.client.client_data.remarks">
            <div class="md-body-2">Klant opmerkingen</div>
            <div class="md-caption md-layout">
                <div class="md-layout-item">
                    {{ planningItem.client.client_data.remarks ? planningItem.client.client_data.remarks : '-' }}
                </div>
            </div>
        </div>

        <div
            id="remarks-block"
            v-if="
                planningItem.planning_item_type === PlanningItemType.repair ||
                planningItem.planning_item_type === PlanningItemType.placement ||
                planningItem.planning_item_type === PlanningItemType.delivery
            "
        >
            <div class="md-body-2">
                {{ getNameOfPlanningItemTypePipe(planningItem.planning_item_type, 'nl') }} opmerkingen
            </div>
            <div class="md-caption md-layout">
                <div class="md-layout-item">
                    {{ planningItem.data.description ? planningItem.data.description : '-' }}
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { IPlanningItemEntity, Language, PlanningItemType } from '@phrospr/api-backend';
import { getNamePlanningItemType } from '@phrospr/lib-core/src/engine/planning-item.engine';

@Component
export default class PlanningDetailPlanningItemView extends Vue {
    public PlanningItemType = PlanningItemType;

    get planningItem(): IPlanningItemEntity {
        return this.$store.state.planningItem;
    }

    getNameOfPlanningItemTypePipe(planningItemType: PlanningItemType, language?: Language) {
        return getNamePlanningItemType(planningItemType, language);
    }
}
</script>

<style scoped>
#back-btn {
    /*float: right;*/
}

.comment-button {
    text-align: right;
}

.md-button[disabled] {
    opacity: 0.5;
}

#address-block {
    margin-top: 10px;
}

#remarks-block {
    margin-top: 10px;
}

#client-remark-block {
    margin-top: 10px;
}

#detail-tab .phone a {
    margin-left: 0;
    margin-right: 0;
    color: rgba(0, 0, 0, 0.54);
}
</style>
